/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-07-07 16:28:07
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-07 14:02:00
 * @FilePath: \ui\src\stores\modelConfig.store.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD
 */
import { atom, useAtom } from 'jotai'
import { useEffect } from 'react'
import { useConversationContext } from './conversation.store'
const currentModelAtom = atom<any>()
const baseModelAtom = atom<any>('DeepSeek')
export const useModelConfigContext = () => {
  const [currentModel, setCurrentModel] = useAtom(currentModelAtom)
  const [baseModel, setBaseModel] = useAtom(baseModelAtom)
  const { aiCapabilities } = useConversationContext()

  const chooseModel = (modelName: string) => {
    setBaseModel(modelName)
  }

  useEffect(() => {
    setCurrentModel(baseModel == '通义千问' ? 'dashscope' : 'deepseek')
  }, [baseModel, aiCapabilities])

  return {
    currentModel,
    baseModel,
    chooseModel,
  }
}
